import { gsap } from 'gsap';


document.addEventListener("DOMContentLoaded", function() {

let groups = gsap.utils.toArray(".accordion-group");
let menus = gsap.utils.toArray(".accordion-menu");
let menuToggles = groups.map(createAnimation);
  menus.forEach((menu) => {
    menu.addEventListener("click", () => toggleMenu(menu));
  });

  function toggleMenu(clickedMenu) {
    menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
  }

  function createAnimation(element) {
    let menu = element.querySelector(".accordion-menu");
    let box = element.querySelector(".accordion-content");
    let plusElement = element.querySelector(".accordion-plus");


    gsap.set(box, { height: "auto" });

    let animation = gsap
      .timeline()
      .from(box, {
        height: 0,
        duration: 0.5,
        ease: "power1.inOut"
      })
      .to(plusElement, { duration: 0.2, rotate: 135, ease:"none" }, 0)
      .reverse();

    return function (clickedMenu) {
      if (clickedMenu === menu) {
        animation.reversed(!animation.reversed());
      } else {
        animation.reverse();
      }
    };
  }
});